import { type ExamLocationRequestRoomPhysicalInfoFormInputs } from './schema';

export interface PhysicalFeatureCheckConfig {
  key: keyof Pick<
    ExamLocationRequestRoomPhysicalInfoFormInputs,
    | 'seatSideSpacing'
    | 'screenDistance'
    | 'seatFrontBackSpacing'
    | 'windows'
    | 'storageLocker'
    | 'examineeStorage'
    | 'securityCameras'
    | 'registrationArea'
    | 'toilets'
    | 'sharedOpenArea'
  >;
  label: string;
  required?: boolean;
  hasImages?: boolean;
  imageInputLabel?: string;
  helperText?: string;
  handlePreviewImage?: (src: string) => void;
}

export const PHYSICAL_FEATURES: PhysicalFeatureCheckConfig[] = [
  { key: 'seatSideSpacing', label: '1.ระยะห่างของเก้าอี้ด้านข้าง 30 ซม.', required: true },
  { key: 'screenDistance', label: '2.ระยะห่างระหว่างหน้าจอ 30 ซม.', required: true },
  {
    key: 'seatFrontBackSpacing',
    label: '3.ระยะห่างของโต๊ะแถวหน้า และแถวหลัง 60 ซม.',
    required: true,
  },
  { key: 'windows', label: '4.ห้องเป็นกระจกมองเห็นจากภายนอก', required: true },
  { key: 'storageLocker', label: '5.มีล็อกเกอร์สำหรับเก็บของ', required: true },
  { key: 'examineeStorage', label: '6.ที่วางสัมภาระสำหรับผู้เข้าสอบ', required: true },
  {
    key: 'securityCameras',
    label: '7.กล้องวงจรปิด',
    required: true,
    hasImages: true,
    imageInputLabel: 'แนบรูปภาพจุดที่ติดตั้งกล้องวงจรปิด',
  },
];

export const AROUND_AREA_FEATURES: PhysicalFeatureCheckConfig[] = [
  {
    key: 'registrationArea',
    label: '1.จุดลงทะเบียน',
    helperText: 'กรอกรายละเอียดเพิ่มเติม เช่น มีบริเวณคับแคบ หรือกว้างขวาง เป็นต้น',
    required: true,
    hasImages: true,
    imageInputLabel: 'แนบรูปภาพบริเวณจุดลงทะเบียน',
  },
  {
    key: 'toilets',
    label: '2.ห้องน้ำ',
    helperText: 'กรอกรายละเอียดเพิ่มเติม เช่น มีเพียงพอ  หรือห่างจากห้องสอบ เป็นต้น',
    required: true,
  },
  {
    key: 'sharedOpenArea',
    label: '3.เป็นพื้นที่เปิด ที่มีการจัดกิจกรรมอื่นร่วมด้วย',
    required: true,
  },
];
